module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_1moment_m.f155788f0075eed6628406adc522c4a3.png";